export const urls = {
  GET_ZAPOSLENI_NA_RN:
    'DokRNServisni/dok_rn_servisni_zaposleni_na_radnom_nalogu',
  GET_DATA_PANEL: 'DokRNServisni/dok_rn_servisni_pregled_dobiti_detaljno',
  GET_USLUGE_DETALJI: 'DokRNServisni/dok_rn_servisni_pregled_usluga_detaljno',
  GET_TRANSPORT_DETALJI:
    'DokRNServisni/dok_rn_servisni_pregled_transport_detaljno',
  GET_DELOVI_DETALJI: 'DokRNServisni/dok_rn_servisni_pregled_delova_detaljno',
  GET_TROSKOVI_DETALJI:
    'DokRNServisni/dok_rn_servisni_pregled_troskova_detaljno',
  GET_LISTA_USLUGA:
    'DokRNServisni/dok_rn_servisni_pregled_usluga_lista_zaposlenih',
  GET_LISTA_TRANSPORT:
    'DokRNServisni/dok_rn_servisni_pregled_transporta_lista_zaposlenih',
  GET_PIE_DATA:
    'DokRNServisni/dok_rn_servisni_pregled_ucesca_zaposlenih_u_dobiti',
};
